wow = new WOW({
                boxClass:     'wowo',      // default
                animateClass: 'animated', // default
                offset:       0,          // default
                mobile:       true,       // default
                live:         true        // default
              });
wow.init();

function menuHamburger(){
    jQuery('.hamburger').on('click', function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery('nav').toggleClass('is-show');
        jQuery('header').toggleClass('nav-show');
        jQuery('body').toggleClass('overflow-hidden');
        jQuery('.layer-out').toggleClass('show');
    });
    jQuery('nav .menu-list .site-nav__dropdown ul li').each(function() {
        jQuery(this).children('a').append('<i class="icon-arrow-smaller"></i>');
    });

    // jQuery('nav .menu-list .site-nav--has-dropdown').on('click', function () {
    //     var sw = document.body.scrollWidth;
    //     var scrollBar = getScrollbarWidth();
    //     if(sw + scrollBar < 768){
    //         jQuery(this).children('.site-nav__dropdown').slideToggle(200);
    //         jQuery(this).siblings().children('.site-nav__dropdown').slideUp(200);
    //     }
    // })
    jQuery('nav .menu-list .site-nav--has-dropdown').hover(function () {
        jQuery(this).addClass('thisHover').siblings('li').removeClass('thisHover');
        jQuery(this).parents('.header-right').addClass('hover');
    },function () {
        jQuery(this).removeClass('thisHover');
        jQuery(this).parents('.header-right').removeClass('hover');
    })
}
function navscroll() {
    var scrollTop = jQuery(window).scrollTop();
    // if(!jQuery('.add-new-15-years').length){
        if(scrollTop >= 10){
            jQuery('header').addClass('smaller-header');
        }else {
            jQuery('header').removeClass('smaller-header');
        }
        jQuery(window).scroll(function(event){
            var scrollTop = jQuery(window).scrollTop();
            if(scrollTop >= 30){
                jQuery('header').addClass('smaller-header');
            }else {
                jQuery('header').removeClass('smaller-header');
            }
        });
    // }


}
function getScrollbarWidth() {
    var odiv = document.createElement('div'),
        styles = {
            width: '100px',
            height: '100px',
            overflowY: 'scroll'
        },
        i, scrollbarWidth;
    for(i in styles) odiv.style[i] = styles[i];
    document.body.appendChild(odiv);
    scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;
    jQuery(odiv).remove();
    return scrollbarWidth;
}
function wowo() {
    if($(document.body).hasClass('template-wholesale')){
      return false;
    }
    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
        var me = jQuery(this), meTop = me.offset().top, meHeight = me.innerHeight(), meBottom = meTop + meHeight,
            limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
        if (meTop > limitTop && meBottom < limitBottom) {
            me.addClass("animated");
            setTimeout(function () {
                me.removeClass("animated wowo");
            }, 1200);
        }
    });
}
function slider(){
    setTimeout(function () {
        if (jQuery('.slick-dots').length > 0){

            jQuery('.slick-dots').each(function () {
                var tt=jQuery(this);
                var index = jQuery(this).children("li").length;

                if(index <= 1){
                    tt.css('display', 'none');
                }
            })
        }
    },10);

  if(jQuery(document.body).find('.wholesale-brands .brand-thumb .brand-item').length > 0){
         jQuery('.wholesale-brands .brand-thumb').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          infinite: false,
          arrows: false,
          focusOnSelect: true,
          responsive: [
              {
                  breakpoint: 991.9,
                  settings: {
                      slidesToShow: 3,
                  }
              },
              {
                  breakpoint: 767.9,
                  settings: {
                      slidesToShow: 2,
                  }
              },
              {
                  breakpoint: 575.9,
                  settings: {
                      slidesToShow: 1,
                      arrows: true,
                  }
              }
          ]
      });
    
  }
	
	
if(jQuery(document.body).find('.mobile-shop-slider').length > 0){	
	jQuery('.mobile-shop-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2000,
		infinite: false,
		arrows: false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 991.9,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 767.9,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 575.9,
				settings: {
					slidesToShow: 1,
					arrows: true,
				}
			}
		]
    });
}
    jQuery('.add-images-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		infinite: true,
		arrows: false,
		dots:true,
		focusOnSelect: true,
		autoplaySpeed: 8000,
		responsive: [
			{
				breakpoint: 992.9,
				settings: {
					slidesToShow: 1,
				}
			},
            {
					breakpoint: 1200.1,
					settings: {
						slidesToShow: 2,
				
					}
			},
			
		]
    });
    jQuery(".add-faqs .block .faqs-title").click(function(event){
			event.stopPropagation();
			jQuery(this).toggleClass("is-active");

			jQuery(this).siblings(".faqs-text").slideToggle(200);
			
			jQuery(this).parents(".block").siblings().find(".faqs-title").removeClass("is-active");

			jQuery(this).parents(".block").siblings().find(".faqs-text").slideUp(200);
			
		
		});

  

   
   if(jQuery(document.body).find('.imgs-slider-unique').length >  0){
     
      jQuery('.imgs-slider-unique').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2000,
		infinite: false,
		arrows: false,
		dots:false,
		focusOnSelect: true,
        centerMode: false,
        fade: true,        
        cssEase: 'ease-in-out',
        adaptiveHeight: true,
    });   

     
     jQuery('.unique-coffee-block .slider-handle').click(function(e){
       e.preventDefault();
       var index = jQuery(this).data('item');      
       $('.imgs-slider-unique').slick('slickGoTo', index);       
     });  
   }

  if(jQuery(document.body).find('.imgs-slider').length >  0){
    jQuery('.imgs-slider').each(function(){
      var _auto = jQuery(this).attr('data-auto');
      var auto_scroll = true;
      if(typeof _auto != 'undefined' && _auto == 'false')
          auto_scroll = false;      
      jQuery(this).slick({
    		slidesToShow: 1,
    		slidesToScroll: 1,
    		autoplay: auto_scroll,
    		autoplaySpeed: 5000, 
    		infinite: true,
    		arrows: false,
    		dots:true,
    		focusOnSelect: true,
    
        }); 
      $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          var slick_id = '#'+slick.$slider[0]['attributes']['id']['value'];                    
          //var dataId = $(slick.$slides[currentSlide]).data('index');  
          var current = $(slick_id).find('.slider-block[data-slick-index=' + currentSlide + ']');
          var next_item = $(slick_id).find('.slider-block[data-slick-index=' + nextSlide + ']'); 
          if(current.find('.scale-video').length > 0 && current.find('.scale-video').hasClass('video-playing')){
            var _video = current.find('a.play-video').attr('data-id');            
            var _type = current.find('a.play-video').attr('data-type');  
            var source = next_item.find('a.play-video').attr('data-url');           
            if(typeof(source) != 'undefined' && source.indexOf('vimeo') > -1)
                _type = 'vimeo';            
            stopCurrentVideo(_video,_type);
          }
          if(next_item.find('.scale-video').length > 0){
            var _video = next_item.find('a.play-video').attr('data-id');            
            var _type = next_item.find('a.play-video').attr('data-type');            
            var source = next_item.find('a.play-video').attr('data-url');
            if(typeof(source) != 'undefined' && source.indexOf('vimeo') > -1)
                _type = 'vimeo';
            play_video_element(_video,_type,source);
          }
      });
    });
  }
    
    jQuery('.col-4-icons .content .block .box').click(function (e) {
			e.preventDefault();
			var href = jQuery(this).attr("href"); 
        	var target = href.split("#")[1];
			jQuery("section").each(function(){
				var this_c=jQuery(this);
				var this_data=jQuery(this).attr("id");
				if(this_data == target){
					jQuery('html,body').stop().animate({scrollTop:this_c.offset().top - 130},600);
				}
			});

	    });
	if (jQuery('.add-new-15-years-slider').length > 0) {
		jQuery('.add-new-15-years-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			fade: false,
			speed: 800,
			slidesToShow: 15,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			//variableWidth: true,

			responsive: [
				{
					breakpoint: 1200.1,
					settings: {
						slidesToShow: 10,
				
					}
				},
				{
					breakpoint: 768.1,
					settings: {
						slidesToShow: 5,
                        centerMode:true,
              			centerPadding: '0px',
						
					}
				},
				{
					breakpoint: 556.1,
					settings: {
						slidesToShow: 3,
                        centerMode:true,
            			centerPadding: '0px',
					}
				},
			]
		});
		jQuery('.add-new-15-years-text-slider').slick({
			dots: false,
			arrows: false,
			infinite: false,
			fade: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			draggable:true,
			adaptiveHeight:true,
		});
		
	}
	jQuery(".add-new-15-years .content .slider-block").click(function(){
		jQuery(this).addClass('is-active');
		jQuery(this).siblings().removeClass('is-active');
		var index_c=jQuery(this).index();
		jQuery('.add-new-15-years-text-slider').slick('slickGoTo',index_c);
		jQuery('.add-new-15-years .content-two .logo-15').addClass('is-hide');
		setTimeout(function(){
		jQuery('.add-new-15-years .content-two-box').addClass('is-show');
		},400);
	});
	jQuery('.add-new-15-years-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		jQuery(".add-new-15-years-slider .slider-block").removeClass('span-is-show');
		jQuery(".add-new-15-years-slider .slider-block").eq(nextSlide - 2).addClass('span-is-show');
		
	});
	var width_window=window.innerWidth;
	if (width_window < 1200.5 & width_window > 768.5) {
		jQuery('.add-new-15-years-slider').slick('slickGoTo', 8);
	}
	if (window.innerWidth < 768.5) {
		jQuery('.add-new-15-years-slider').slick('slickGoTo', 8);
		jQuery(".add-new-15-years .content .slider-block").click(function(){
	
			var index_c=jQuery(this).index();
			jQuery('.add-new-15-years-slider').slick('slickGoTo',index_c);
		});
		jQuery(".add-new-15-years .slick-arrow").click(function(){
			jQuery('.add-new-15-years .content-two .logo-15').addClass('is-hide');
			setTimeout(function(){
			jQuery('.add-new-15-years .content-two-box').addClass('is-show');
			},400);
			
			
			
			var ss=jQuery(".add-new-15-years .slick-current").index();
			jQuery(".add-new-15-years-slider .slider-block").eq(ss).addClass('is-active');
			jQuery(".add-new-15-years-slider .slider-block").eq(ss).siblings().removeClass('is-active');
			
			jQuery('.add-new-15-years-text-slider').slick('slickGoTo',ss);
			
			if(ss == 1){
				jQuery(".add-new-15-years-slider .slider-block").eq(0).addClass('first-child');
			}else{
				jQuery(".add-new-15-years-slider .slider-block").eq(0).removeClass('first-child');
			}
			//first-child
		});
        jQuery('.add-new-15-years-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			jQuery(".add-new-15-years-slider .slider-block").removeClass('is-active');
			jQuery(".add-new-15-years-slider .slider-block").eq(nextSlide).addClass('is-active');
		});
//		setTimeout(function(){
//			jQuery('.add-new-15-years-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
//				jQuery('.add-new-15-years-text-slider').slick('slickGoTo',nextSlide);
//				jQuery(".add-new-15-years .content .slider-block").removeClass('is-active');
//				jQuery(".add-new-15-years .content .slider-block").eq(nextSlide).addClass('is-active');
//			});
//		},1000);
		
	}
	
	
    if(jQuery(document.body).find('.banner-top-slider').length > 0){	
      jQuery('.banner-top-slider:not(".slick-initialized")').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          dots: true,
          infinite: true,
          speed: 600,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoplaySpeed: 5000,
          cssEase: 'cubic-bezier(0, 0, 0.58, 1)'
      });
      jQuery('.banner-top-slider .slider-list').addClass('move');
      jQuery('.banner-top-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          jQuery('.banner-top-slider .slider-list').removeClass('move');
          setTimeout(function(){
              jQuery('.banner-top-slider .slider-list').addClass('move');
          },400);
      });
      jQuery('.banner-top-slider .slick-dots').append('<li class="prev-arrow"></li><li class="next-arrow"></li>');
      jQuery('body').on('click', '.banner-top-slider .slick-dots .prev-arrow', function (e) {
          e.preventDefault();
          jQuery('.banner-top-slider .slick-prev').trigger('click');
      });
      jQuery('body').on('click', '.banner-top-slider .slick-dots .next-arrow', function (e) {
          e.preventDefault();
          jQuery('.banner-top-slider .slick-next').trigger('click');
      })
    }

   if(jQuery(document.body).find('.sustainability-top .product-slider').length > 0){	
      jQuery('.sustainability-top .product-slider:not(".slick-initialized")').slick({
          centerMode: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          fade: false,
          speed: 800,
          infinite: true,
          // autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: false,
          responsive: [
              {
                  breakpoint: 991.98,
                  settings: {
                      variableWidth: false,
                      slidesToShow: 1,
                  }
              },
              {
                  breakpoint: 767.98,
                  settings: {
                      variableWidth: false,
                      slidesToShow: 2,
                  }
              },
              {
                  breakpoint: 575.98,
                  settings: {
                      variableWidth: false,
                      slidesToShow: 1,
                  }
              }
          ]
      });
   }

  if(jQuery(document.body).find('.product-slider').length > 0){	
      jQuery('.product-slider:not(".slick-initialized")').slick({
          centerMode: false,
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          fade: false,
          speed: 800,
          infinite: true,
          centerMode: true,
          centerPadding: '0',
          autoplay: false,
          autoplaySpeed: 5000,
          focusOnSelect: false,
  		pauseOnHover:false,
          responsive: [
              {
                  breakpoint: 991.98,
                  settings: {
                      variableWidth: false,
                      slidesToShow: 1,
                  }
              },
              {
                  breakpoint: 575.98,
                  settings: {
                      variableWidth: false,
                      slidesToShow: 1,
                  }
              }
          ]
      });
  }
  if(jQuery(document.body).find('.shop-list-slider').length > 0){		
    jQuery('.shop-list-slider:not(".slick-initialized")').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991.9,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767.9,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575.9,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                }
            }
        ]
    });
  }
if(jQuery(document.body).find('.location-slider').length > 0){	
    jQuery('.location-slider:not(".slick-initialized")').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        arrows: false,
        focusOnSelect: true
    });
}

  
	
if(jQuery(document.body).find('.store-photo-mobile-slider').length > 0){		
    jQuery('.store-photo-mobile-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        arrows: true,
        focusOnSelect: true,
    });
    jQuery('.locations-content .left-box .locations-list h2').on('click', function () {
        var sw = document.body.scrollWidth;
        var scrollBar = getScrollbarWidth();
        if(sw + scrollBar < 768){
            if(!jQuery(this).hasClass('active')){
                setTimeout(function() {
                    jQuery('html,body').stop().animate({scrollTop:me.offset().top - 95},500);
                }, 210);
            }
            var me = jQuery(this).parents('.locations-list');
            jQuery(this).toggleClass('active').parents('.locations-list').siblings().find('h2').removeClass('active');
            jQuery(this).siblings('.list-item').slideToggle(200);
            jQuery(this).parents('.locations-list').siblings().children('.list-item').slideUp(200);
            
            
            jQuery('.store-photo-mobile-slider').slick('refresh');
            // jQuery(this).siblings('.list-item').find('.store-photo-mobile-slider').slick({
            // 	slidesToShow: 1,
            // 	slidesToScroll: 1,
            // 	autoplay: false,
            // 	autoplaySpeed: 2000,
            // 	infinite: true,
            // 	arrows: true,
            // 	focusOnSelect: true,
            // });
            // jQuery(this).parents('.locations-list').siblings().children('.list-item').find('.slick-slider').slick('unslick');

        }
    });
}
  console.log("Loading slider here");
  if(jQuery(document.body).find('.store-photo-slider').length > 0){	
		jQuery('.store-photo-slider').slick({
			slidesToShow: 3,
			centerMode:true,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 2000,
			infinite: true,
			arrows: true,
			focusOnSelect: true,
		});
				
        jQuery('.locations-content .locations-list').on('click', function () {
			var index = jQuery(this).index();
			if(!jQuery(this).hasClass('active')){
				jQuery(this).siblings().removeClass('active');
				jQuery(this).addClass('active');
				jQuery('.locations-content-image .slider-list').eq(index).siblings().hide();
				jQuery('.locations-content-image .slider-list').eq(index).fadeIn();
				jQuery('.store-photo-slider').slick('refresh');
				// jQuery('.locations-content-image .slider-list').eq(index).siblings().find('.slick-slider').slick('unslick');
				// jQuery('.locations-content-image .slider-list').eq(index).find('.store-photo-slider').slick({
				// 	slidesToShow: 3,
				// 	centerMode:true,
				// 	slidesToScroll: 1,
				// 	autoplay: false,
				// 	autoplaySpeed: 2000,
				// 	infinite: true,
				// 	arrows: true,
				// 	focusOnSelect: true,
				// });
				
				jQuery('.locations-content-text .tab-content').eq(index).siblings().hide();
				jQuery('.locations-content-text .tab-content').eq(index).fadeIn();
			}
        })
  }
if(jQuery(document.body).find('.wholesale-slider').length > 0){		
	jQuery('.wholesale-slider').slick({
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    autoplay: false,
	    autoplaySpeed: 2000,
	    infinite: true,
	    arrows: true,
	    dots: false,
	});
}
if(jQuery(document.body).find('.image-slider').length > 0){		  
    jQuery('.image-slider:not(".slick-initialized")').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: true,
        dots: true,
        focusOnSelect: true
    });
    
}

  if(jQuery('.product-detail-slider').length>0){
        jQuery('.slider-for').on('init', function(slick) {
          jQuery('.slider-for').addClass('show');
          jQuery('.slider-nav').addClass('show');
        });
        jQuery('.slider-for:not(".slick-initialized")').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            draggable: false,
            asNavFor: '.slider-nav'
        });
        jQuery('.slider-nav:not(".slick-initialized")').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            arrows: false,
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            centerPadding: '0',
            // verticalSwiping: true,
            // vertical: true,
        });
    }
}
function video(){
    jQuery(".video-link.mp4").click(function(event){
        event.preventDefault();
        jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
        jQuery(document).bind("touchmove",function(event){event.preventDefault()});
        var video_url = jQuery(this).find('.data-video').html();
        jQuery('.video-light-box').find('.play-iframe-video').append('<video controls="controls" autoplay="autoplay"><source src="'+video_url+'" type="video/mp4"></video>');
        jQuery('.video-light-box').fadeIn(300);
    });
    jQuery(".video-link.file").click(function(event){
        event.preventDefault();
        jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
        jQuery(document).bind("touchmove",function(event){event.preventDefault()});
        var video_url = jQuery(this).find('.data-video').html();
        jQuery('.video-light-box').find('.play-iframe-video').append('<video controls="controls" autoplay="autoplay"><source src="'+video_url+'" type="video/mp4"></video>');
        jQuery('.video-light-box').fadeIn(300);
    });
    jQuery(".video-link.embed").click(function(event){
        event.preventDefault();
        jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
        jQuery(document).bind("touchmove",function(event){event.preventDefault()});
        jQuery('.video-light-box').fadeIn(300);
        var html = jQuery(this).find('.data-video').html();
        jQuery('.video-light-box').find('.play-iframe-video').html(html);
    });
    jQuery('.video-light-box .close').click(function(){
        jQuery(document).unbind("mousewheel DOMMouseScroll");
        jQuery(document).unbind("touchmove");
        jQuery('.video-light-box').fadeOut(300);
        setTimeout(function(){
            jQuery('.video-light-box').find('.play-iframe-video').html('');
        },300);
    });
    jQuery('.video-light-box').click(function(){
        jQuery(document).unbind("mousewheel DOMMouseScroll");
        jQuery(document).unbind("touchmove");
        jQuery('.video-light-box').fadeOut(300);
        setTimeout(function(){
            jQuery('.video-light-box').find('.play-iframe-video').html('');
        },300);
    });
    jQuery('.video-light-box .video-box').click(function(event){
        event.stopPropagation();
    });
}
function accordion(){
    if(jQuery(".accordion").length > 0) {
        jQuery(".accordion .accordion-title").click(function(e) {
            e.preventDefault();
            var me = jQuery(this),
                parent = me.parents(".accordion-list");
            me.parents('.shopify-section').siblings('').find('.accordion-content').slideUp();
            me.parents('.shopify-section').siblings('').find('.accordion-list').removeClass('is-active');
            if(!parent.hasClass("is-active")) {
                me.next().stop().slideDown();
                parent.addClass("is-active").siblings("").removeClass("is-active").find(".accordion-content").slideUp();
            } else {
                parent.removeClass("is-active").find(".accordion-content").slideUp();
            }
            setTimeout(function() {
                jQuery('html,body').stop().animate({scrollTop:me.offset().top - 95},500);
            }, 400);
        });
        jQuery(".faq .right-box .shopify-section:nth-child(1) .accordion .accordion-list").eq(0).addClass("is-active");
        jQuery(".faq .right-box .shopify-section:nth-child(1) .accordion .accordion-list:nth-child(1) .accordion-content").css('display','block');
    }
}
function shopHeight(){
    var heightA = [];
    var heightA2 = [];
    jQuery('.shop-list .list').each(function () {
        heightA.push(jQuery(this).find('.img img').innerHeight());
    });
    jQuery('.shop-list-slider .list').each(function () {
        heightA2.push(jQuery(this).find('.img img').innerHeight());
    });
    var maxH = Math.max(...heightA);
    var maxH2 = Math.max(...heightA2);
    jQuery('.shop-list .list .img').css('min-height', maxH);
    jQuery('.shop-list-slider .list .img').css('min-height', maxH2);
}
function shopNumber(){
    //product +-
    jQuery('body').on('click', '.product-form__controls-group .minus', function (e) {
        e.preventDefault();
        var val = Number(jQuery(this).siblings('input[type="number"]').val());
        if(val <= 1){

        }else {
            var valEnd = val -= 1;
            jQuery(this).siblings('input[type="number"]').val(valEnd);
        }
    })
    jQuery('body').on('click', '.product-form__controls-group .plus', function (e) {
        e.preventDefault();
        var val = Number(jQuery(this).siblings('input[type="number"]').val());
        var valEnd = val += 1;
        jQuery(this).siblings('input[type="number"]').val(valEnd);
    });
    //cart +-
    jQuery('body.template-cart').on('click', '.cart .cart__row .minus', function (e) {
        e.preventDefault();
        var val = Number(jQuery(this).siblings('input[type="number"]').val());
        if(val <= 1){
            jQuery('.cart .cart__footer .btn--loader').trigger('click');
        }else {
            var valEnd = val -= 1;
            jQuery(this).siblings('input[type="number"]').val(valEnd);
            jQuery('.cart .cart__footer .btn--loader').trigger('click');
        }
    })
    jQuery('body.template-cart').on('click', '.cart .cart__row .plus', function (e) {
        e.preventDefault();
        var val = Number(jQuery(this).siblings('input[type="number"]').val());
        var valEnd = val += 1;
        jQuery(this).siblings('input[type="number"]').val(valEnd);
        jQuery('.cart .cart__footer .btn--loader').trigger('click');
    });
}
function form(){
    jQuery('.pop-up-form form .globo-form-control ul li .checkbox-label').on('click', function () {
        jQuery(this).siblings('input[type="checkbox"]').trigger('click');
    });
}
function popUp(){

	var cookie_t = jQuery('header .toolbar').html();
	var modal_t = jQuery.cookie('open-modal-form');
	if (modal_t != cookie_t) {
		jQuery('.toolbar').hide().slideDown();
	}
	jQuery('header .toolbar .close-btn').click(function(event) {
		event.preventDefault();
		jQuery.cookie('open-modal-form', cookie_t, { expires: 30, path: '/' });
		jQuery('.toolbar').slideUp();
	});
	
	
		
    jQuery('.wholesale-form-btn').on('click', function (e) {
        e.preventDefault();
        jQuery('.wholesale-form').fadeIn(300);
        jQuery('.wholesale-form').addClass('up');
        if(jQuery('.wholesale-form form .content .form-submit').length>0){

        }else{
            jQuery('.wholesale-form form .block-container').append('<div class="form-submit"><input type="submit" value="SEND"></div>');
            jQuery('body').on('click', '.wholesale-form form .block-container .form-submit input', function () {
                jQuery('.footer button').trigger('click');
            })
        }
        jQuery('.pop-up-form .pop-up-form-close').on('click', function (e) {
            e.preventDefault();
            jQuery('.pop-up-form').fadeOut(300);
            jQuery('.wholesale-form').removeClass('up');
            jQuery('.wholesale-roaster-form').removeClass('up');
        })
        jQuery('.pop-up-form form .message').on('click', function () {
            jQuery(this).fadeOut(300);
        });
        var email1 = ['','matthewlewin@onacoffee.com.au','matthewlewin@onacoffee.com.au','matthewlewin@onacoffee.com.au','matthewlewin@onacoffee.com.au','rhys@onacoffee.com.au','rhys@onacoffee.com.au','matthewlewin@onacoffee.com.au','matthewlewin@onacoffee.com.au','hester@onacoffee.com.au'];
        jQuery('.wholesale-form form .globo-form-control select.classic-input').change(function () {
            var index = jQuery('option:selected', '.wholesale-form form .globo-form-control select.classic-input').index();
            var val = email1[index];
            jQuery('.wholesale-form form .block-container .globo-form-control').eq(0).find('input').val(val);
          
        });
    })
    jQuery('.wholesale-roaster-form-btn').on('click', function (e) {
        e.preventDefault();
        jQuery('.wholesale-roaster-form').fadeIn(300);
        jQuery('.wholesale-roaster-form').addClass('up');
        if(jQuery('.wholesale-roaster-form form .block-container .form-submit').length>0){

        }else{
            jQuery('.wholesale-roaster-form form .block-container').append('<div class="form-submit"><input type="submit" value="SEND"></div>');
            jQuery('body').on('click', '.wholesale-roaster-for form .content .form-submit input', function () {
                jQuery('.footer button').trigger('click');
            })
        }
        jQuery('.pop-up-form .pop-up-form-close').on('click', function (e) {
            e.preventDefault();
            jQuery('.pop-up-form').fadeOut(300);
            jQuery('.wholesale-form').removeClass('up');
            jQuery('.wholesale-roaster-form').removeClass('up');
            jQuery('.pop-up-form form .message').fadeOut(300);
        })
        jQuery('.pop-up-form form .message').on('click', function () {
            jQuery(this).fadeOut(300);
        })
        var email2 = ['','hany@onacoffee.com.au','hany@onacoffee.com.au'];
        jQuery('.wholesale-roaster-form form .globo-form-control select.classic-input').change(function () {
            var index = jQuery('option:selected', '.wholesale-roaster-form form .globo-form-control select.classic-input').index();
            var val = email2[index];
            jQuery('.wholesale-roaster-form form .block-container .globo-form-control').eq(0).find('input').val(val);
        });
    })
	
	var email3 = ['','admin@onacoffee.com.au','marketing@onacoffee.com.au'];
	jQuery("body").on("change",".get-in-touch select.classic-input",function(){
		var index = jQuery('option:selected', '.get-in-touch form .globo-form-control select.classic-input').index();
		for(var i=0;i<email3.length;i++){
			var val = email3[index];
			jQuery('.get-in-touch form .block-container .globo-form-control:nth-child(1)').children('input').val(val);
		}
	});
	
	jQuery('body').on('click', function () {
	    jQuery('.get-in-touch form .message').fadeOut(300);
	});
	jQuery('body').on('click', function () {
	    jQuery('.training-form form .message').fadeOut(300);
	});
	
    jQuery('.pop-up-form').on('click', function () {
        jQuery('.pop-up-form').fadeOut(300);
        jQuery('.wholesale-form').removeClass('up');
        jQuery('.wholesale-roaster-form').removeClass('up');
        jQuery('.pop-up-form form .message').fadeOut(300);
    });
    jQuery('.pop-up-form .form-box .box').click(function(e){
        e.stopPropagation();
    });
}
function animated(){
    lines_0();
    lines_1();
    lines_2();
    lines_3();
    lines_4();
    lines_5();
    lines_6();
    lines_7();

    line_1();
    line_2();
    line_3();
    line_4();
    line_5();
    line_6();
    line_7();
    var nowTime = 0;
    var lastTime = Date.now();
    var diffTime = 12000;
    (function animloop() {
        nowTime = Date.now()
        if(nowTime-lastTime > diffTime){
            lastTime = nowTime
            lines_0();
            lines_1();
            lines_2();
            lines_3();
            lines_4();
            lines_5();
            lines_6();
            lines_7();

            line_1();
            line_2();
            line_3();
            line_4();
            line_5();
            line_6();
            line_7();
        }
        window.requestAnimationFrame(animloop);
    })();
    function lines_0() {
        jQuery('svg path.starts-0').each(function(){
            TweenMax.to(".starts-0", 5, {morphSVG:".mediums-0" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-0').each(function(){
                TweenMax.to(".starts-0", 5, {morphSVG:".ends-0" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-0').each(function(){
                    TweenMax.to(".starts-0", 5, {morphSVG:".starts-01" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_1() {
        jQuery('svg path.starts-1').each(function(){
            TweenMax.to(".starts-1", 5, {morphSVG:".mediums-1" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-1').each(function(){
                TweenMax.to(".starts-1", 5, {morphSVG:".ends-1" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-1').each(function(){
                    TweenMax.to(".starts-1", 5, {morphSVG:".starts-1" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_2() {
        jQuery('svg path.starts-2').each(function(){
            TweenMax.to(".starts-2", 5, {morphSVG:".mediums-2" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-2').each(function(){
                TweenMax.to(".starts-2", 5, {morphSVG:".ends-2" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-2').each(function(){
                    TweenMax.to(".starts-2", 5, {morphSVG:".starts-2" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_3() {
        jQuery('svg path.starts-3').each(function(){
            TweenMax.to(".starts-3", 5, {morphSVG:".mediums-3" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-3').each(function(){
                TweenMax.to(".starts-3", 5, {morphSVG:".ends-3" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-3').each(function(){
                    TweenMax.to(".starts-3", 5, {morphSVG:".starts-3" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_4() {
        jQuery('svg path.starts-4').each(function(){
            TweenMax.to(".starts-4", 5, {morphSVG:".mediums-4" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-4').each(function(){
                TweenMax.to(".starts-4", 5, {morphSVG:".ends-4" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-4').each(function(){
                    TweenMax.to(".starts-4", 5, {morphSVG:".starts-4" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_5() {
        jQuery('svg path.starts-5').each(function(){
            TweenMax.to(".starts-5", 5, {morphSVG:".mediums-5" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-5').each(function(){
                TweenMax.to(".starts-5", 5, {morphSVG:".ends-5" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-5').each(function(){
                    TweenMax.to(".starts-5", 5, {morphSVG:".starts-5" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_6() {
        jQuery('svg path.starts-6').each(function(){
            TweenMax.to(".starts-6", 5, {morphSVG:".mediums-6" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-6').each(function(){
                TweenMax.to(".starts-6", 5, {morphSVG:".ends-6" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-6').each(function(){
                    TweenMax.to(".starts-6", 5, {morphSVG:".starts-6" });
                });
            }, 4000);
        }, 4000);

    }
    function lines_7() {
        jQuery('svg path.starts-7').each(function(){
            TweenMax.to(".starts-7", 5, {morphSVG:".mediums-7" });
        });
        setTimeout(function () {
            jQuery('svg path.starts-7').each(function(){
                TweenMax.to(".starts-7", 5, {morphSVG:".ends-7" });
            });
            setTimeout(function () {
                jQuery('svg path.starts-7').each(function(){
                    TweenMax.to(".starts-7", 5, {morphSVG:".starts-7" });
                });
            }, 4000);
        }, 4000);

    }

    function line_1() {
        jQuery('svg path.start').each(function(){
            TweenMax.to(".start", 5, {morphSVG:".medium" });
        });
        setTimeout(function () {
            jQuery('svg path.start').each(function(){
                TweenMax.to(".start", 5, {morphSVG:".end" });
            });
            setTimeout(function () {
                jQuery('svg path.start').each(function(){
                    TweenMax.to(".start", 5, {morphSVG:".start" });
                });
            }, 4000);
        }, 4000);

    }
    function line_2() {
        jQuery('svg path.start-2').each(function(){
            TweenMax.to(".start-2", 5, {morphSVG:".medium-2" });
        });
        setTimeout(function () {
            jQuery('svg path.start-2').each(function(){
                TweenMax.to(".start-2", 5, {morphSVG:".end-2" });
            });
            setTimeout(function () {
                jQuery('svg path.start-2').each(function(){
                    TweenMax.to(".start-2", 5, {morphSVG:".start-2" });
                });
            }, 4000);
        }, 4000);

    }
    function line_3() {
        jQuery('svg path.start-3').each(function(){
            TweenMax.to(".start-3", 5, {morphSVG:".medium-3" });
        });
        setTimeout(function () {
            jQuery('svg path.start-3').each(function(){
                TweenMax.to(".start-3", 5, {morphSVG:".end-3" });
            });
            setTimeout(function () {
                jQuery('svg path.start-3').each(function(){
                    TweenMax.to(".start-3", 5, {morphSVG:".start-3" });
                });
            }, 4000);
        }, 4000);

    }
    function line_4() {
        jQuery('svg path.start-4').each(function(){
            TweenMax.to(".start-4", 5, {morphSVG:".medium-4" });
        });
        setTimeout(function () {
            jQuery('svg path.start-4').each(function(){
                TweenMax.to(".start-4", 5, {morphSVG:".end-4" });
            });
            setTimeout(function () {
                jQuery('svg path.start-4').each(function(){
                    TweenMax.to(".start-4", 5, {morphSVG:".start-4" });
                });
            }, 4000);
        }, 4000);

    }
    function line_5() {
        jQuery('svg path.start-5').each(function(){
            TweenMax.to(".start-5", 5, {morphSVG:".medium-5" });
        });
        setTimeout(function () {
            jQuery('svg path.start-5').each(function(){
                TweenMax.to(".start-5", 5, {morphSVG:".end-5" });
            });
            setTimeout(function () {
                jQuery('svg path.start-5').each(function(){
                    TweenMax.to(".start-5", 5, {morphSVG:".start-5" });
                });
            }, 4000);
        }, 4000);

    }
    function line_6() {
        jQuery('svg path.start-6').each(function(){
            TweenMax.to(".start-6", 5, {morphSVG:".medium-6" });
        });
        setTimeout(function () {
            jQuery('svg path.start-6').each(function(){
                TweenMax.to(".start-6", 5, {morphSVG:".end-6" });
            });
            setTimeout(function () {
                jQuery('svg path.start-6').each(function(){
                    TweenMax.to(".start-6", 5, {morphSVG:".start-6" });
                });
            }, 4000);
        }, 4000);

    }
    function line_7() {
        jQuery('svg path.start-7').each(function(){
            TweenMax.to(".start-7", 5, {morphSVG:".medium-7" });
        });
        setTimeout(function () {
            jQuery('svg path.start-7').each(function(){
                TweenMax.to(".start-7", 5, {morphSVG:".end-7" });
            });
            setTimeout(function () {
                jQuery('svg path.start-7').each(function(){
                    TweenMax.to(".start-7", 5, {morphSVG:".start-7" });
                });
            }, 4000);
        }, 4000);

    }
}
function preorderProduct() {
// 	jQuery('.product-form__cart-submit').click(function() {
// 	  var text = jQuery(this).text();
// 	  if(text=='Preorder Now'){
// 		console.log('popup!');
// 		jQuery('.preorder-tips-popup').addClass('show-popup');
// 	  }
// 	});
	jQuery('.preorder-tips-popup .close-btn').click(function(event) {
		event.stopPropagation();
		jQuery('.preorder-tips-popup').removeClass('show-popup');
	});
	jQuery('.preorder-tips-popup').click(function(event) {
		event.stopPropagation();
		jQuery('.preorder-tips-popup').removeClass('show-popup');
	});
	jQuery('.preorder-tips-popup .popup-box').click(function(event) {
		event.stopPropagation();
	});
	
}

function customCartRemove() {



  
  	jQuery('.custom-cart-remove-line').click(function() {
      	var item_id = jQuery(this).parents('.cart__row').attr('data-item-id');
        jQuery.ajax({
            url:'/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: { quantity:0, id:item_id },
            success: function(msg) {
               location.reload();
            }
        });
	});
}

function productTab() {
	jQuery('.coffee-tab ul li button').click(function() {
		jQuery(this).parent().siblings().removeClass('active');
		jQuery(this).parent().addClass('active');
		var index = jQuery(this).parent().index();
		jQuery(this).parents('.coffee-tab').siblings('.coffee-tab-content').find('.coffee-table').hide();
		jQuery(this).parents('.coffee-tab').siblings('.coffee-tab-content').find('.coffee-table').eq(index).fadeIn();
	});
}
function productTabHeight() {
	var height = 0;
	jQuery('.coffee-table').css('min-height',0);
	jQuery('.coffee-table').each(function() {
		console.log(jQuery(this).innerHeight());
		if(jQuery(this).innerHeight()>height){
			height = jQuery(this).innerHeight();
		}
	});
	jQuery('.coffee-table').css('min-height',height);
}

function productGoToBrew() {
	jQuery('.profile .blogs-link').click(function() {
		var top = jQuery('section.guide').offset().top;
		var header_h = jQuery('header').innerHeight();
		jQuery('html,body').stop().animate({scrollTop:top-header_h},800);
	});
}

function newsFilter(){
    jQuery('body').on('click','.news-list-wrap .filter-select ul button',function(){
        var btnText = jQuery(this).text();
        var btnVal = jQuery(this).attr('data-tag');
        jQuery('.news-list-wrap .filter-select .current-value').text(btnText).attr('data-current-tag',btnVal);
        jQuery(this).parents('ul').fadeOut(300);
    })
    
    jQuery('body').on('click','.news-list-wrap .filter-select .current-value',function(e){
        jQuery(this).siblings('ul').fadeToggle(300);
        e.stopPropagation();
    })

    jQuery('body').on('click',function(){
        jQuery('.news-list-wrap .filter-select ul').fadeOut(300);
    })
}


jQuery(document).ready(function(jQuery) {
    jQuery('html').addClass("show-c");
    jQuery('.w-webflow-badge').remove();
    wowo();
    customCartRemove();
	preorderProduct();
    menuHamburger();
    getScrollbarWidth();
    slider();
    video();
    navscroll();
    accordion();
    shopHeight();
    shopNumber();
    form();
   popUp();
    animated();
	productTab();
	productTabHeight();
	productGoToBrew();
    newsFilter();

  if(jQuery(document.body).find('.match-height').length > 0){
    $('.match-height').matchHeight({byRow: true,property: 'height'});
  }

  if(jQuery(document.body).find('.equal-height').length > 0){
    $('.equal-height').matchHeight({byRow: true,property: 'height'});
  }
  
  jQuery('.filter-form .ajax-filter-btn').click(function() {
    var tag = jQuery('.filter-form .current-value').attr('data-current-tag');
    if(tag == 'all'){
      var baseUrl = '/blogs/news?page=1';
      jQuery('.ajax-load-more-news-btn').attr('data-post-type','/blogs/news?page=');
    }else{
      var baseUrl = '/blogs/news/tagged/'+tag+'?page=1';
      jQuery('.ajax-load-more-news-btn').attr('data-post-type','/blogs/news/tagged/'+tag+'?page=');
    }
    console.log(baseUrl);
    jQuery('.ajax-load-more-news-btn').attr('data-current-page','1');
    jQuery('.news-list').addClass('loading');
    jQuery.ajax({
      url: baseUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        jQuery('.news-list').html(jQuery(responseHTML).find('.news-list').html());
        jQuery('.news-list').removeClass('loading');
        if(jQuery(responseHTML).find('.ajax-load-more-news-btn').length){
          var max = jQuery(responseHTML).find('.ajax-load-more-news-btn').attr('data-max-page');
        }else{
          var max = 1;
        }
        if(max<2){
          jQuery('.ajax-load-more-news-btn').hide();
        }else{
          jQuery('.ajax-load-more-news-btn').show();
        }
      },
      complete: function() {
      
      }
    });

    
  });


  
  jQuery('.ajax-load-more-news-btn').click(function() {
    var page = parseInt(jQuery(this).attr('data-current-page'))+1;
    var baseUrl = jQuery(this).attr('data-post-type')+page;
    jQuery(this).attr('data-current-page',page);
    jQuery(this).addClass('loading');
    var jQuerythis = jQuery(this);
    jQuery.ajax({
      url: baseUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        console.log(jQuery(responseHTML).find('.news-list').html());
        jQuerythis.removeClass('loading');
        var max = parseInt(jQuerythis.attr('data-max-page'));
        var afterpage =  parseInt(jQuerythis.attr('data-current-page'));
        jQuery('.news-list').append(jQuery(responseHTML).find('.news-list').html());
        if(afterpage>=max){
          jQuerythis.hide();
        }
      },
      complete: function() {
      
      }
    });
  });

  
    // setTimeout(function () {
    //     jQuery('form.product-form').show();
    // }, 3000);
	jQuery(".back-to-top").click(function(){
		jQuery('html,body').stop().animate({scrollTop:0},500);
	});
    jQuery(".form-group.country-input input").click(function(event){
        event.stopPropagation();
        jQuery(this).siblings(".typeahead__result").css("display","block");
        jQuery(this).parent(".form-group").siblings().children("ul").slideUp(300);
        jQuery(".overflow-c").mCustomScrollbar({
            axis:"y",
        });
    });
    jQuery(".form-group.country-input input").keyup(function(event){
        jQuery(".overflow-c").mCustomScrollbar({
            axis:"y",
        });
    });
    jQuery("body").click(function(event){
//         event.stopPropagation();
        jQuery(".typeahead__result").css("display","none");
        jQuery(".form-group.select-input ul").fadeOut(3);
    });




//jquery.typeahead
    var data=new Array();
    jQuery('.form-group.typeahead__container ul li').each(function(){
        var me=jQuery(this);
        data.push(me.text());
    })

    typeof jQuery.typeahead === 'function' && jQuery.typeahead({
        input: ".typeahead",
        minLength: 0,
        maxItem: 20,
        maxItemPerGroup: 20,
        order: "asc",
        searchOnFocus: true,

        source: {
            teams: {
                data: data
            }
        },
        emptyTemplate: 'No result for "{{query}}"',
        callback: {
            onClickAfter: function (node, a, item, event) {
                event.preventDefault();

                var txt=a.text();
                // node.parents('.screen').find('.names span').text(txt);
                // jQuery('.typeahead__cancel-button').trigger('click')
            },

        },
    });

    jQuery('.filters-footer .see-all').attr('target','_self');
    jQuery('.filters-content .list ul li a').click(function (e) {
        e.preventDefault();
        if(jQuery(this).parent().index()==0){
            jQuery(this).parent().addClass('active');
            jQuery(this).parent().siblings().removeClass('active');
        }else{
            jQuery(this).parent().toggleClass('active');
            if(jQuery(this).parents('ul').find('.active').length>0){
                jQuery(this).parents('ul').children().eq(0).removeClass('active');
            }else{
                jQuery(this).parents('ul').children().eq(0).addClass('active');
            }
        }
        var filter = '';
        var x = 0;
        jQuery('.filters-content .list ul li.active').each(function () {
            if(jQuery(this).index()!=0){
                if(x==0){
                    filter = jQuery(this).children().attr('data-handle');
                }else{
                    filter = jQuery(this).children().attr('data-handle') + '+' + filter;
                }
                x++;
            }
        });

        var cat = '';
        if(jQuery('.tab-filter').hasClass('blog-tab')){
            cat = jQuery('.blog-tab').find('li.active').attr('data-tag');
            var url = cat;
        }

        if(filter == ''){
            var url = jQuery('.filters-content').attr('data-back-url')+filter+cat;
        }else{
            if(cat == ''){
                var url = jQuery('.filters-content').attr('data-url')+filter;
            }else{
                var url = jQuery('.filters-content').attr('data-url')+cat+'+'+filter;
            }
        }



        jQuery.ajax(
            {
                url:url,
                type:'GET',
                dataType:'html'
            }
        ).done(function(next_page){
            var new_products = jQuery(next_page).find('.shop-list');
            var count = new_products.attr('data-count');
            if(count>1){
                jQuery('.ajax-count').text('SEE '+count+' RESULTS');
            }else if(count==1){
                jQuery('.ajax-count').text('SEE '+count+' RESULT');
            }else{
                jQuery('.ajax-count').text('NO RESULTS');
            }
        });


        jQuery('.filters-footer .see-all').attr('href',url);

    });


    jQuery('.filters-footer .clear-filter').click(function (e) {
        e.preventDefault();
        jQuery('.filters-content .list').each(function () {
            jQuery(this).find('ul').find('li').removeClass('active');
            jQuery(this).find('ul').find('li').eq(0).addClass('active');
        });
        var url = jQuery('.filters-content').attr('data-back-url');
        jQuery.ajax(
            {
                url:url,
                type:'GET',
                dataType:'html'
            }
        ).done(function(next_page){
            var new_products = jQuery(next_page).find('.shop-list');
            var count = new_products.attr('data-count');
            if(count>1){
                jQuery('.ajax-count').text('SEE '+count+' RESULTS');
            }else if(count==1){
                jQuery('.ajax-count').text('SEE '+count+' RESULT');
            }else{
                jQuery('.ajax-count').text('NO RESULTS');
            }
        });
        jQuery('.filters-footer .see-all').attr('href',url);
    });

    jQuery('header .header-right .icon-list .icon-search').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery('#SearchDrawer').addClass('is-show');
        jQuery('#SearchDrawer .search-bar__form input[type="text"]').focus();
    });
    jQuery('#SearchDrawer').on('click', function (e) {
        e.stopPropagation();
    });
    jQuery('.shop-top .filter').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery('.filters-wrapper').addClass('is-show');
    })
    jQuery('.filters-header .icon-close').on('click', function (e) {
        e.stopPropagation();
        jQuery(this).parents('.filters-wrapper').removeClass('is-show');
    });
    jQuery('.filters-wrapper').on('click', function (e) {
        e.stopPropagation();
        jQuery(this).addClass('is-show');
    });
    jQuery('body').on('click', function () {
        jQuery('#SearchDrawer .search-bar__form input[type="text"]').val('');
        jQuery('#SearchDrawer').removeClass('is-show');
        jQuery('.filters-wrapper').removeClass('is-show');
    });
    jQuery("#SearchDrawer .search-bar__actions .search-bar__close").on('click', function () {
        jQuery('#SearchDrawer .search-bar__form input[type="text"]').val('');
        jQuery('#SearchDrawer').removeClass('is-show');
    })
    //shop hover
    jQuery('.blog-detail-top .go-to-next-modules a').on('click', function (e) {
        e.preventDefault();
        var moduleH = jQuery(this).parents('.blog-detail-top').siblings('.guide').offset().top;
        var headerH = jQuery('header').innerHeight();
        jQuery('html,body').stop().animate({scrollTop:moduleH - headerH},500);
    })
    jQuery('.shop-list .list .add-to-cart a').hover(function () {
        jQuery(this).parents('.add-to-cart').siblings('.list-box').addClass('hover');
    },function () {
        jQuery('.shop-list .list .list-box').removeClass('hover');
    })
    jQuery('.shop-list .list .list-box').hover(function () {
        jQuery(this).siblings('.add-to-cart').children('a').addClass('hover');
    },function () {
        jQuery('.shop-list .list .add-to-cart a').removeClass('hover');
    });
    //our range
    jQuery('.our-range .shop-filter ul li:nth-child(1)').addClass('active');
    jQuery('.our-range .main .main-list:nth-child(1)').addClass('show');
    jQuery('.our-range .shop-filter ul li').on('click', function(e){
        e.preventDefault();
        //switch
        jQuery(this).addClass('active').siblings().removeClass('active');
        var $i=jQuery(this).index();
        jQuery('.our-range .main').children('.main-list').eq($i).show();
        // setTimeout(function(){
        //     jQuery('.main').find('.main-list').eq($i).siblings().hide()
        // },500);
        setTimeout(function(){
            jQuery('.our-range .main .main-list').eq($i).addClass('show');
        },450);
        jQuery('.our-range .main').children('.main-list').eq($i).css({
            position: 'static',
            width: '100%',
        });
        jQuery('.our-range .main').children('.main-list').eq($i).siblings().css({
            position: 'absolute',
            top: 0
        });
        jQuery('.our-range .main').children('.main-list').eq($i).siblings().removeClass('show');
    });

    //instafeed
    if(jQuery("#instafeed").length>0){
        var dataUrl = jQuery(".follow-us").attr('data-url');
        var feed = new Instafeed({
            accessToken: InstagramToken,
            limit: 4,
            template: '<div class="instagram-list"><a class="instagram-c" href=" '+ dataUrl +' " target="_blank" style="background-image:url({{image}});"></a></div>',
            after: function () {},
        });
        feed.run();
    }

    //load more
    jQuery('.awards .right-box table tr').each(function () {
        if(jQuery(this).index()<6){
            jQuery(this).addClass('is-show');
            jQuery(this).css('display','table-row');
        }
    });
    if(jQuery('.awards .right-box table tr').length == jQuery('.awards .right-box table tr.is-show').length){
        jQuery('.awards .right-box .more-btn').css('display','none');
    }
    jQuery(".awards .right-box .more-btn").on("click", function(e){
        e.preventDefault();
        var a = jQuery('.awards .right-box table tr.is-show').length+6;
        jQuery('.awards .right-box table tr').each(function () {
            if(jQuery(this).index()<a){
                jQuery(this).addClass('is-show').fadeIn();
            }
        });
        if(jQuery('.awards .right-box table tr').length == jQuery('.awards .right-box table tr.is-show').length){
            jQuery('.awards .right-box .more-btn').css('display','none');
        }
    });

    jQuery('.site-nav--active ul li a').on('click', function () {
        if(jQuery(this).children('span').text() == 'Stockists'){
            setTimeout(function () {
                var urlId = window.location.hash;
                var thatId = jQuery('.store-finder').attr('data-id');
                var thisId = urlId.substr(1);
                if(thisId == thatId){
                    var moduleH = jQuery('.store-finder').offset().top;
                    var headerH = jQuery('header').innerHeight();
                    jQuery('html,body').stop().animate({scrollTop:moduleH - headerH},500);
                }
            },10)
        }
    });
    jQuery(".add-pop-up .add-pop-up-box .content .colse").on('click', function (e) {
        e.preventDefault();
        jQuery(".add-pop-up").fadeOut(400);
    });
	jQuery(".add-pop-up").on('click', function (e) {
	        e.stopPropagation();
        jQuery(".add-pop-up").fadeOut(400);
    });
    jQuery(".add-pop-up .add-pop-up-box .content").on('click', function (e) {
	        e.stopPropagation();
    });

    if($(document.body).find('a.scale-cover-video.play-video').length > 0){
      $('a.scale-cover-video.play-video').each(function(){
          var _auto = $(this).data('auto');
  
       
          if(typeof _auto == 'boolean' && _auto){
              var player_id = $(this).data('id');
              var type = $(this).data('type');
              var video_id = $(this).data('video'); 
              var videoUrl = $(this).data('url'); 
              
              if(videoUrl.indexOf('vimeo') > -1)
                  type = 'vimeo';
              play_video_element(player_id,type,video_id);
          }
       
      });

       setTimeout(function(){
            $('.video-playing.video-vimeo').each(function(){  
              if($(this).find('iframe.vimeo-paused').length > 0){               
                 var play_id = $(this).find('iframe').attr('id');
                  var Pauseiframe = jQuery('#'+play_id);
                  var pause_player = new Vimeo.Player(Pauseiframe);
                  pause_player.setVolume(0);
            	  pause_player.play();
                
              }              
            });
        },5000);
    }
    jQuery('a.play-video').click(function(){
      var player_id = $(this).data('id');
      var type = $(this).data('type');
      var video_id = $(this).data('video'); 
      var videoUrl = $(this).data('url'); 
      
      if(videoUrl.indexOf('vimeo') > -1)
          type = 'vimeo';
      play_video_element(player_id,type,video_id);
  });

  if(jQuery(document.body).find('.video-vimeo').length > 0){
        jQuery(document.body).find('.video-vimeo').each(function(){
            var _src = jQuery(this).find('iframe').attr('src');
            console.log("Source",_src);
        });
  }

  jQuery('a.icon-box-anchor').hover(function(){
       var _img = $(this).find('.icon-c img');
       if(_img.hasClass('animate__heartBeat')){
         _img.removeAttr('style').removeClass('animate__heartBeat').addClass('animate__bounceIn');
       }else{
         _img.removeAttr('style').addClass('animate__heartBeat').removeClass('animate__bounceIn');
       }      
   },function(){
         var _img = $(this).find('.icon-c img');
         _img.removeAttr('style').removeClass('animate__bounceIn');     
   });
  hide_single_dots();
  
});
//jQuery(window).on('load', function () {
jQuery(document).ready(function () {
    wowo();
    shopHeight();
  if(jQuery(document.body).find('.shopify-section').length > 0){
     jQuery('.shopify-section').imagesLoaded( function() {//kai
         var urlId = window.location.hash;
         var thatId = jQuery('.store-finder').attr('data-id');
         var thisId = urlId.substr(1);
         if(thisId == thatId){
             var moduleH = jQuery('.store-finder').offset().top;
             var headerH = jQuery('header').innerHeight();
             jQuery('html,body').stop().animate({scrollTop:moduleH - headerH},500);
         }
     });
  }

  if(jQuery(document.body).find('.recommendations-list .shop-list').length > 0){
	jQuery('.recommendations-list .shop-list').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2000,
		infinite: false,
		arrows: false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 991.9,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 767.9,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 575.9,
				settings: {
					slidesToShow: 1,
					arrows: true,
				}
			}
		]
    });
  }
	
});

jQuery(window).scroll(function() {
    wowo();
    hide_single_dots();
});
jQuery(window).on('resize',function() {
    shopHeight();
	productTabHeight();
    hide_single_dots();
});

function hide_single_dots(){
  jQuery(document.body).find('.slick-dots').each(function(){
      if(jQuery(this).find('li').length <= 1){
        $(this).remove();
      }
  });
}

function play_video_element(player_id,video_type,video_id){
    /* $('.scale-video.video-playing').each(function(){
        var player_id = $(this).parent().find('a.play-video').attr('data-id');       
        var type = $(this).parent().find('a.play-video').attr('data-type');
        var source = $(this).parent().find('a.play-video').attr('data-url');
        if(source.indexOf('vimeo') > -1)
          type = 'vimeo';       
        stopCurrentVideo(player_id,type);
     });*/
  
     var curren_item = $('#'+player_id);
     curren_item.parent().addClass('video-playing').show();
     curren_item.parent().parent().find('.scale-cover-video').hide(); 
     curren_item.parent().parent().find('.scale-cover-image').hide(); 

     curren_item.parent().addClass('video-playing').addClass('video-'+video_type).addClass('player-'+player_id); 
     if(video_type == 'upload'){			
		var _video = document.getElementById(player_id);
        if(video_id.indexOf('.m3u8') > -1 && Hls.isSupported()){
          var hls = new Hls();
          hls.loadSource(video_id);
          hls.attachMedia(_video);   
          _video.play();
        }else{
          _video.src = video_id;          
        } 
         _video.muted = true; 
       // _video.controls = false; 
       $("#"+player_id).bind("ended", function() {

             var loop_video = document.getElementById(player_id);
             loop_video.play();
             loop_video.muted = true; 
            // loop_video.controls = false; 
           /* $("#"+player_id).parent().removeClass('video-playing').hide();
            $("#"+player_id).parent().parent().find('.scale-cover-video').show();    
            $("#"+player_id).parent().parent().find('.scale-cover-image').show();    */
       });
	}else if(video_type == 'vimeo'){
		var iframe = jQuery('#'+player_id);
        //$('#'+player_id).attr('src','https://vimeo.com/'+video_id);
        //var _src = "https://player.vimeo.com/video/"+video_id+"?controls=0"; 
        //$('#'+player_id).attr('src','https://vimeo.com/'+video_id);
        //iframe.attr('src',_src);                
		var vimeo_player = new Vimeo.Player(iframe);
        vimeo_player.setVolume(0); 
  		vimeo_player.play();
        vimeo_player.getPaused().then(function(paused) {
            if(paused){
                $('#'+vimeo_player.element.id).addClass('vimeo-paused');              
            }else{
               console.log("API LAYED");
            }        
        });
        //vimeo_player.setControl(0);
		/*vimeo_player.on('play', function(){
			vimeo_player.off('play')
			vimeo_player.loadVideo(video_id).then(function(){
				vimeo_player.setAutopause(false).then(function(autopause) {
				  // wait 1 second then play  
				  //setTimeout(play2,1000);
			   });
			});
		});*/
        vimeo_player.on('ended', function(event) {          
            $('.video-playing.video-vimeo').each(function(){
                /*var play_id = $(this).find('iframe').attr('id');
                if($(this).hasClass('player-'+play_id)){
                  $(this).removeClass('video-playing').hide();
                  $(this).parent().find('.scale-cover-video').show();
                  $(this).parent().find('.scale-cover-image').show();
                }*/
                var play_id = $(this).find('iframe').attr('id');
                var Loopiframe = jQuery('#'+play_id);
                var loop_player = new Vimeo.Player(Loopiframe);
                loop_player.setVolume(0);
        		loop_player.play();
                
            });            
        });			
	}else{		
       console.log('youtube video_id',video_id);
       jQuery('#'+player_id).replaceWith('<div id="'+player_id+'"></div>');
		//jQuery('#'+player_id).replaceWith('<iframe id="'+player_id+'" frameborder="0" allowfullscreen="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="YouTube video player" width="640" height="360" src="https://www.youtube.com/embed/'+video_id+'?autoplay=1&mute=1&show_info=0&controls=0&loop=1&html5=1&amp;wmode=opaque&amp;origin=https%3A%2F%2Fonacoffee.com.au&amp;enablejsapi=1&amp;widgetid=2" data-gtm-yt-inspected-6="true"></iframe>');
		OnaonYouTubeIframeAPIReady(video_id,player_id);
	}
}

function stopCurrentVideo(player_id,type){  
  return false;
  if(type == 'upload'){
     var _video = document.getElementById(player_id);
     _video.pause();
    console.log("vidoe stop");
  }else if(type == 'vimeo'){    
      var iframe = jQuery('#'+player_id);
      var stopplayer = new Vimeo.Player(iframe);     
      stopplayer.pause();
     //stopplayer.pause();
     //$('#'+player_id).attr('src','');
     //player.api("pause");
     
  }else{	
     jQuery('#'+player_id).replaceWith('<div id="'+player_id+'"></div>');
  }
  $("#"+player_id).parent().removeClass('video-playing').hide();
  $("#"+player_id).parent().parent().find('.scale-cover-video').show();    
  $("#"+player_id).parent().parent().find('.scale-cover-image').show();  
}  
  
function OnaonYouTubeIframeAPIReady(video_id,player_id) {
   
	if(typeof video_id != 'undefined'){		
		player = new YT.Player(player_id,{	 
		videoId: video_id,
		rel:0,
		showinfo:0,
      //  controls:0,
        loop:1,
        mute:0,  
        playerVars: {
          html5: 1,
          'wmode': 'opaque',
      //    'controls': 0,
          'origin': 'https://www.youtube.com'
        },
		events: {
			'onReady': onPlayerReady,
            'onStateChange': function(event){
                  onPlayerStateChange(event, player_id);
                }			
		  }
		});
	}
 }
function onPlayerReady(event) {
    event.target.playVideo();
    event.target.mute();
	
	/*iframe = $('#player');
	var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
	if (requestFullScreen) {
		requestFullScreen.bind(iframe)();
	}*/
}
var done = false;
function onPlayerStateChange(event,player_id) {
	if(event.data === 0) {
        event.target.playVideo();
        event.target.mute();
        /*$("#"+player_id).parent().removeClass('video-playing').hide();
        $("#"+player_id).parent().parent().find('.scale-cover-video').show(); 
        $("#"+player_id).parent().parent().find('.scale-cover-image').show(); */
	}
}

function stopVideo(){
    
}